<template>
	<div class="pronto-drag-sort" @dragenter.stop @dragstart.stop @dragover.stop>
		<Sortable
			:list="items"
			:options="mergedOptions"
			:itemKey="itemKey"
			:tag="tag"
			:key="rerenderKey"
			v-bind="$attrs"
			@start="onDragStart"
			@end="onDragEnd"
			@unchoose="onDragStop"
		>
			<template #item="{ element, index }">
				<slot name="item" :item="element" :index="index" />
			</template>
		</Sortable>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import { moveItemInArray } from '@/helpers/utils'
import bus from '@/helpers/bus'
// TODO: replace sortablejs-vue3 with some better DnD library in the future because
// sortablejs-vue3 has plenty of quirks that have been difficult to code around
// Ex1: we have to import Sortable in this specific order so it gets configured correctly
// See: https://github.com/MaxLeiter/sortablejs-vue3#using-plugins
import SortableJS, { AutoScroll } from 'sortablejs/modular/sortable.core.esm.js'
if (!SortableJS.mountedAutoScroll) {
	// Ex2: if this plugin mounts after it has happened once, we get this exception:
	// Sortable: Cannot mount plugin scroll more than once
	SortableJS.mount(new AutoScroll())
	SortableJS.mountedAutoScroll = true
}
import { Sortable } from 'sortablejs-vue3'

let orderedKeys = []
const sortableOptions = {
	animation: 150,
	ghostClass: 'ghost',
	dragClass: 'dragger',
	scroll: true,
	bubbleScroll: true,
}

const props = defineProps({
	items: Array,
	options: Object,
	itemKey: { type: String, default: 'id' },
	tag: { type: String, default: 'div' },
})
const emit = defineEmits(['change', 'start', 'stop', 'end'])
defineOptions({ inheritAttrs: false })

const mergedOptions = computed(() =>
	Object.assign({}, sortableOptions, props.options || {})
)

// Ex3: this forces SortableJS to reinitialize whenever the parent updates props.items
// which forces SortableJS to stay in sync with the reactive vue props
const rerenderKey = computed(() =>
	props.items.map((item) => item[props.itemKey]).join(',')
)

const onDragStart = () => {
	bus.$emit('toggleDragZone', false)
	emit('start')
}
const onDragStop = () => {
	bus.$emit('toggleDragZone', true)
	emit('stop')
}
const onDragEnd = (e) => {
	onDragStop()
	emit('end', e)
	if (orderedKeys.length !== props.items.length) {
		orderedKeys = props.items.map((item) => item[props.itemKey])
	}
	moveItemInArray(orderedKeys, e.oldIndex, e.newIndex)
	emit('change', orderedKeys)
}
</script>
